export const environment = {
    production: false,
    staging: true,
    apiUrl: 'https://api.chauffeurprodriver.com',
    appUrl: 'https://dashboard.chauffeurprodriver.com',
    googleMapsApiKey: 'AIzaSyArZUkxEJGI4tijMiX5RUXQnlgmHvZU-AU',
    version: '1.0.0',
    buildNumber: '20261102-090754-223d998',
};
